let value = ("undefined" !== typeof self ? self : this)["webpackJsonpvuecal"] || [];
(value).push([[20], {
    "03b7": function (e) {
        e.exports = JSON.parse(`{
            "weekDays": ["월", "화", "수", "목", "금", "토", "일"],
            "months": ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
            "years": "년도",
            "year": "연간",
            "month": "월간",
            "week": "주간",
            "day": "일간",
            "today": "오늘",
            "noEvent": "일정 없음",
            "allDay": "하루 종일",
            "deleteEvent": "삭제",
            "createEvent": "일정 추가",
            "dateFormat": "YYYY년 MMMM D일 dddd요일"
        }`)
    }
}]);